import { Component, PropTypes } from 'react';
import moment from 'moment-timezone/moment-timezone';
import styles from 'styles/timeTo';

export default class TimeTo extends Component {
	static propTypes = {
		time: PropTypes.string.isRequired
	}

	render() {
		return (
			<span className={styles.labelTimeTo}>
				<span className={styles.iconTime} />
				{moment(this.props.time).fromNow()}
			</span>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./scripts/components/TimeTo.es6
 **/